import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'next/router'
import { Link } from '../routes'
import { formatPrice, numericText } from '../utils/format';

class Header extends React.Component {
  render() {
    const { categories, subcategories, partitions, cart, router: { query } } = this.props;

    return (
      <div id="header">
        <div className="top-bar">
          <ul className="item item-menu menu menu-pages">
            <li className="item">
              <Link href="/about/shipping"><a>Доставка</a></Link>
            </li>
            <li className="item">
              <a href="#">Для клиентов</a>
              <div className="submenu submenu-blocks">
                <div className="submenu-block">
                  <Link href="/about/discounts"><a>Программа скидок</a></Link>
                  <Link href="/about/payment"><a>Способы оплаты</a></Link>
                  <Link href="/about/reviews"><a>Ваши отзывы</a></Link>
                </div>
              </div>
            </li>
            <li className="item">
              <Link href="/about/"><a>О нас</a></Link>
            </li>
            <li className="item">
              <Link href="/about/contacts"><a>Контакты</a></Link>
            </li>
          </ul>
          <Link href="/cabinet">
            <a className="item item-cabinet">Ваш кабинет</a>
          </Link>
          <div className="separator" />
          <Link href="/cart">
            <a className="item item-cart">
              <i className="icon icon-cart" />
              <strong>Корзина: </strong>
              {cart.quantity} {numericText(cart.quantity, 'товар', 'товара', 'товаров')} на <b>{formatPrice(cart.subtotal)}</b>
            </a>
          </Link>
        </div>

        <div className="inner">
          <div className="left">
            <Link route="index"><a id="logo"></a></Link>
            <div className="title">
              Крупнейшний<br />магазин Аюрведы
            </div>
            <i className="sticker sticker-since2003" />
          </div>

          <div className="right">
            <div className="item item-phone">
              <a href="tel:+74951201054">
                +7 495 120 10 54
                <i className="icon icon-phone"></i>
              </a>
            </div>
            <div className="item item-shipping">
              <i className="icon icon-shipping" />
              Доставка по всей России
            </div>
            <div className="item item-worktime">
              <i className="icon icon-worktime" />
              <strong>Режим работы:</strong>
              <p>Пн-Пт 9:00-19:00</p>
              <p>Сб-Вс 10:00-17:00</p>
            </div>
          </div>
        </div>

        <div className="bottom-bar">
          <ul className="item item-menu menu menu-categories">
            {categories.map(category => (
              <li key={category.id} className={`item ${query.category === category.slug ? 'item-active' : ''}`}>
                <Link route="category" params={{ category: category.slug }}>
                  <a href={`/${category.slug}`}>
                    {category.name}
                  </a>
                </Link>
                <div className="submenu submenu-blocks">
                  {subcategories.filter(subcategory => partitions.some(partition => partition.category == category.id && partition.subcategory == subcategory.id)).map(subcategory => (
                    <div key={`${category.id}-${subcategory.id}`} className="submenu-block">
                      {partitions.filter(partition => partition.visible && partition.category == category.id && partition.subcategory == subcategory.id).map(partition => (
                        <Link key={partition.id} route="category" params={{ category: category.slug, partition: partition.slug }}>
                          <a href={`/${category.slug}/${partition.slug}`} className={query.partition == partition.slug ? 'item-active' : null}>
                            {partition.name}
                            {partition.isNew && (
                              <sup>new!</sup>
                            )}
                          </a>
                        </Link>
                      ))}
                    </div>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="bottom-bar">
          <ul className="item item-menu menu menu-pages">
            <li className="item">
              <Link href="/new"><a>Новинки</a></Link>
            </li>
            <li className="item">
              <Link href="/hit"><a>Топ средств</a></Link>
            </li>
            <li className="item">
              <Link href="/actions"><a>Акции</a></Link>
            </li>
            <li className="item">
              <Link href="/sale"><a>Распродажа</a></Link>
            </li>
            <li className="item"> 
              <Link href="/blog"><a>Блог</a></Link>
            </li>
          </ul>
          <div className="item item-search">
            <form className="search" action="/search" acceptCharset="UTF-8" method="get">
              <input name="q" placeholder="Поиск товаров" type="text" defaultValue="" />
              <button type="submit"><i className="icon icon-search" /></button>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  categories: state.categories,
  subcategories: state.subcategories,
  partitions: state.partitions,
  cart: state.cart,
})

const mapDispatchToProps = dispatch => ({
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
